import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { redirect } from '../redux/reducer/user';
import { userInfo } from '../api';
import { Redirect } from 'react-router-dom';

@withRouter
@connect(
  state=>state.user,
  {redirect}
)
class AuthRoute extends React.Component{
  componentDidMount() {
    // userInfo()
    //   .then(res=>{
    //     if (res.status === "success") {
    //       this.props.redirect({redirectTo: ''});
    //       if (this.props.location.pathname === "/admin") {
    //         this.props.history.push('/admin/dashboard');
    //       }
    //     }
    //   })
    //   .catch(err=>err);
    if (sessionStorage.getItem("token") && sessionStorage.getItem("adminName")) {
      this.props.redirect({redirectTo: ''});
      if (this.props.location.pathname === "/admin") {
        this.props.history.push('/admin/dashboard');
      }
    }
  }
  render() {
    if (this.props.redirectTo && this.props.redirectTo !== this.props.location.pathname) {
      return <Redirect to={this.props.redirectTo} />
    }
    return null;
  }
}

export default AuthRoute;


// WEBPACK FOOTER //
// ./src/component/authroute.js